import React from 'react';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import insertInArrayIf from '@zola-helpers/client/dist/es/util/insertInArrayIf';

import GearIcon from '@zola/zola-ui/src/components/SvgIcons/Gear';
import QuestionIcon from '@zola/zola-ui/src/components/SvgIcons/Question';
import ChatIcon from '@zola/zola-ui/src/components/SvgIcons/Chat';
import SearchIcon from '@zola/zola-ui/src/components/SvgIcons/Search';
import ShoppingBagIcon from '@zola/zola-ui/src/components/SvgIcons/ShoppingBag';

import featureFlags from 'util/featureFlags';

import type { MobileNavLink } from '../MobileNavMenuData';

type MobileNavUtilityLink = MobileNavLink & {
  icon: JSX.Element;
  rel?: string;
  target?: string;
  children?: MobileNavLink[];
};

export const accountSettingsPaths = [
  '/account/settings/info',
  '/account/settings/wedding',
  '/account/settings/orders',
  '/account/settings/reviews',
  '/account/settings/credits',
  '/account/settings/privacy',
  '/wedding-registry/invite',
];

const getMobileWebsiteMenuData = (userContext: UserContext): MobileNavUtilityLink[] => {
  const isGuest = Boolean(userContext.is_guest);
  const hasWeddingAccount = Boolean(userContext.has_wedding_account);
  const hasRegistry = Boolean(userContext.has_registry);
  const hasMarketplaceAccount = Boolean(userContext.has_marketplace_account);
  const findCouple = {
    title: 'Find a Couple',
    path: '/search/wedding-registry',
    icon: <SearchIcon width={24} height={24} />,
  };
  const getHomestorePath = () => {
    switch (featureFlags.getEnvironment()) {
      case 'development':
        return 'http://127.0.0.1:9000';
      case 'staging':
        return 'https://qa-homestore.zola.com';
      case 'production':
      default:
        return 'https://homestore.zola.com';
    }
  };
  return [
    ...insertInArrayIf(!isGuest, {
      title: 'Account Settings',
      path: '/account/settings/info',
      icon: <GearIcon width={24} height={24} />,
      children: [
        {
          title: 'Your account',
          path: '/account/settings/info',
        },
        {
          title: 'Your wedding details',
          path: '/account/settings/wedding',
        },
        {
          title: "Orders you've placed",
          path: '/account/settings/orders',
        },
        {
          title: 'Ratings and reviews',
          path: '/account/settings/reviews',
        },
        {
          title: 'Zola store credit',
          path: '/account/settings/credits',
        },
        ...insertInArrayIf(hasRegistry || hasWeddingAccount, {
          title: 'Privacy settings',
          path: '/account/settings/privacy',
        }),
        ...insertInArrayIf(hasMarketplaceAccount, {
          title: 'Hellos from vendors',
          path: '/account/settings/hellos-from-vendors',
        }),
        { title: 'Invite friends', path: '/wedding-registry/invite' },
      ],
    }),
    ...insertInArrayIf(isGuest, findCouple),
    {
      title: 'Help',
      path: '/faq',
      icon: <QuestionIcon width={24} height={24} />,
      rel: 'nofollow noopener',
      target: '_blank',
    },
    {
      title: 'Contact Us',
      path: '/contact-us',
      icon: <ChatIcon width={24} height={24} />,
    },
    ...insertInArrayIf(!isGuest, findCouple),
    {
      title: 'Switch to Home Store',
      path: getHomestorePath(),
      icon: <ShoppingBagIcon width={24} height={24} />,
    },
  ];
};

export default getMobileWebsiteMenuData;
